export default function registerUserContentTypeHeader () {
  return {
    accept: '*/*',
    'Content-Type': 'application/json'
  }
}
